import { render, staticRenderFns } from "./OverlayLoading.vue?vue&type=template&id=572253cc&scoped=true&"
import script from "./OverlayLoading.vue?vue&type=script&lang=js&"
export * from "./OverlayLoading.vue?vue&type=script&lang=js&"
import style0 from "./OverlayLoading.vue?vue&type=style&index=0&id=572253cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572253cc",
  null
  
)

export default component.exports